import React, { useState } from 'react'
import { useTranslation } from 'i18n'
import CircleArrowSVG from 'images/inline/arrow-button3.svg'
import AwesomeDebouncePromise from 'awesome-debounce-promise'

const ArrowButton3 = ({
  isLastStep = false,
  visible = true,
  clickable = false,
  onClick = function () {},
  className,
}) => {
  const { t } = useTranslation(['stepShell', 'common'])
  const [doubleClickTimeoutActive, setDoubleClickTimeoutActive] =
    useState(false)

  // wrapper to prevent double clicking, which absolutely WRECKS OUR NUMBERS
  const handleClick = e => {
    e.preventDefault()
    if (doubleClickTimeoutActive === false) {
      setDoubleClickTimeoutActive(true)
      onClick && onClick()
      setTimeout(function () {
        setDoubleClickTimeoutActive(false)
      }, 2000)
    }
  }
  return (
    <div
      className={`next-step-button-container ${
        !clickable ? 'is--disabled' : 'is--enabled'
      }`}
    >
      {!isLastStep && visible && (
        <button
          className={`next-step-button ${className ? className : ''}`}
          onClick={handleClick}
          disabled={!clickable}
          aria-label={t('common:next')}
        >
          <CircleArrowSVG alt={t('stepShell:nextStepIconAlt')} />
          <span className={`next-step-button-text`}>
            {t('common:nextActivity')}
          </span>
        </button>
      )}
    </div>
  )
}

export default ArrowButton3
